import { render } from "./UserManagementDialog.vue?vue&type=template&id=b15ed27e&scoped=true"
import script from "./UserManagementDialog.vue?vue&type=script&lang=js"
export * from "./UserManagementDialog.vue?vue&type=script&lang=js"

import "./UserManagementDialog.vue?vue&type=style&index=0&id=b15ed27e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15ed27e"]])

export default __exports__